const SANS_SERIF = "sans-serif";

export const fontFamily = {
  "sys-default": [ "SctoRegular", SANS_SERIF ],
  "sys-bold": [ "SctoBold", SANS_SERIF ],
  "sys-display": [ "GreedBold", SANS_SERIF ],
} as const;
